export const API_URL: string = 'https://api.ontiloo.com/api/v1';
// export const API_URL: string = 'http://ec2-18-216-120-236.us-east-2.compute.amazonaws.com:1027/api/v1';
export const MAX_ITEMS_PER_PAGE: number = 10;
export const KEY_ID_ACCOUNT_SELECED: string = 'KEY_ID_ACCOUNT_SELECED';